export type FileWithContent = File & { content: string };

export const readFile = async (file: File): Promise<FileWithContent | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      if (!e.target) {
        return reject(new Error('FileReader error: target is null'));
      }

      const content = e.target?.result;

      if (typeof content !== 'string') {
        return reject(new Error('FileReader error: result is not a string'));
      }

      return resolve(Object.assign(file, { content }));
    };

    reader.readAsText(file);
  });
};
